import React from 'react'
import RestaurantInfo from '../../components/desktop/restaurant-info'

import { useSelector } from 'react-redux'

const RestaurantInfoContainer = ({ backToList }) => {
    const restaurantInfo = useSelector(state => state.RestaurantReducer)

    return (
        <RestaurantInfo
            restaurantInfo={restaurantInfo}
            backToList={backToList}
        />
    )
}

export default RestaurantInfoContainer
